import type { Customer } from "@/types/customers";

/**
 * CCA Details applies only to a client in the CCA segment (AB#7087). One rule
 * for the client page's tab strip and the Energy Advisor sidebar row
 * (AB#8740), so the two can never disagree about which clients have it.
 */
export function isCcaClient(
  customer: Pick<Customer, "segments"> | undefined,
): boolean {
  return customer?.segments.some((s) => s.name === "CCA") ?? false;
}
